import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(3),
    gap: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexShrink: 0,
  },
  filename: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: 0.5,
    color: theme.palette.labraText.description,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  iconButton: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    borderRadius: 4,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '& svg': {
      fontSize: 10,
      color: theme.palette.labraText.description,
    },
    '&:hover': {
      backgroundColor: theme.palette.labraChat.hoverBg,
    },
  },
  frame: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    border: 'none',
    borderRadius: 8,
    backgroundColor: theme.palette.bg.light,
  },
}))
